import { useAlterCollection } from "@/hooks/useCollection";
import { IAlterCollectionAction } from "@/interfaces/bundle.interface";
import { contentListIdsState } from "@/stores/cart";
import { IconButton } from "@material-ui/core";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import React from "react";
import { useRecoilValue } from "recoil";

interface IProps {
  collectionId: string;
  refetch: () => Promise<void>;
  verbose: boolean;
}

const DeleteButton: React.FC<IProps> = ({ collectionId, refetch, verbose }) => {
  const { loading, alterCollection } = useAlterCollection();
  const ids = useRecoilValue(contentListIdsState);

  const handleDelete = async () => {
    await alterCollection({
      collectionId,
      action: IAlterCollectionAction.REMOVE,
      paperIds: ids,
    });
    await refetch();
  };

  if (!verbose) return null;

  return (
    <IconButton color="primary" onClick={handleDelete} disabled={loading}>
      <DeleteOutlineIcon />
    </IconButton>
  );
};

export default DeleteButton;
